export enum MfaMethod {
  email = 'Email',
  sms = 'Sms',
}
